module.exports = __webpack_public_path__ + "images/babboe8324afb6173fb342e1101c242b2c42ac.png";